var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElementVelocit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 34,
    viewBox: "0 0 32 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.788 30.7165C12.7972 31.8009 15.0536 32.3453 17.3363 32.2962C19.6189 32.2471 21.8498 31.6063 23.8106 30.4364C25.7713 29.2666 27.3948 27.6078 28.5223 25.6224C29.6497 23.6369 30.2424 21.3928 30.2424 19.1096C30.2424 16.8263 29.6497 14.5822 28.5223 12.5968C27.3948 10.6113 25.7713 8.95251 23.8106 7.78268C21.8498 6.61284 19.6189 5.97204 17.3363 5.92296C15.0536 5.87387 12.7972 6.4182 10.788 7.50267M1.75781 12.7785H9.14402M1.75781 25.4406H9.14402M1.75781 19.1096H4.92333M26.5544 9.61301L28.1371 8.03025M17.0578 5.39232V1.69922M17.0578 1.69922H12.3095M17.0578 1.69922H21.8061M21.8061 14.3613L16.5302 19.6371",
    stroke: "#353A0A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElementVelocit);
export default __webpack_public_path__ + "static/media/ElementVelocità.6ada85bcbfb0a909ff39de58813a4437.svg";
export { ForwardRef as ReactComponent };